
/**
 * Module dependencies.
 */

import { Faq } from 'src/types/faqs';
import { media, units } from 'src/styles/utils';
import { normalizeNewLine } from 'src/core/utils/strings';
import Disclosure from 'src/components/disclosure';
import RawHtml from 'src/components/core/raw-html';
import React, { ReactElement, useState } from 'react';
import styled from 'styled-components';

/**
 * `Props` types.
 */

type Props = Pick<Faq, 'answer' | 'question'>

/**
 * `Content` styled component.
 */

const Content = styled.div`
  padding: ${units(2)} ${units(1.5)} ${units(4)} ${units(1.5)};

  ${media.min('ms')`
    padding: ${units(5)} 0 ${units(5)} ${units(3)};
  `};
`;

/**
 * `FaqDisclosure` component.
 */

const FaqDisclosure = (props: Props): ReactElement => {
  const { answer, question } = props;
  const [isOpen, setOpen] = useState<boolean>();

  return (
    <Disclosure
      isFaq
      isOpen={isOpen}
      title={question}
      toggle={() => setOpen(!isOpen)}
    >
      <Content>
        <RawHtml>
          {normalizeNewLine(answer)}
        </RawHtml>
      </Content>
    </Disclosure>
  );
};

/**
 * Export `FaqDisclosure` component.
 */

export default FaqDisclosure;
